module.exports = __webpack_public_path__ + "img/invite-bg-tw.6a52b972.png";